import BasfiKindergartenReport from '../dto/basfi/KindergartenReport';
import Error from '../model/Error';
import axios from 'axios';

export default class BasfiKindergartenReportRepository {
    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/basfi/reports`)
                .then((response) => resolve(response.data.data.map((report) => BasfiKindergartenReport.fromData(report))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static buildPreview(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/basfi/reports/current`)
                .then((response) => resolve(BasfiKindergartenReport.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
